var map = {
	"./cloud.png": "43a2",
	"./gitlab.png": "3012",
	"./guide.png": "1629",
	"./guide_1.png": "0e75",
	"./guide_2.png": "29e6",
	"./mail.png": "87b1",
	"./openproject.png": "77f7",
	"./project-analysis.png": "a526",
	"./acrobat-reader.png": "a527"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b7d";